import React from 'react';
import { motion } from 'framer-motion';

import LinkKort from './components/LinkKort';

import { ILinkListe } from './linkListe.definition';

const LinkListe = (props: ILinkListe) => {
	const { overskrift = ' ', cta, links } = props;

	const container = {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				staggerChildren: 0.125
			}
		}
	};

	const item = {
		hidden: { opacity: 0, y: 6 },
		show: { opacity: 1, y: 0, transition: { ease: 'linear' } }
	};

	return (
		<div className="row">
			<div className="columns">
				<section className="servicetjek-link-liste">
					{ (overskrift || cta?.url) && (
						<div className="link-liste__head">
							<h3>{ overskrift }</h3>

							{ cta?.url && (
								<div className="link-liste__cta">
									<a
										className="button button--liv"
										target={ cta.target }
										href={ cta.url }
									>
										{ cta.title }
									</a>
								</div>
							) }
						</div>
					) }


					{ links && links.length > 0 && (
						<motion.div
							animate="show"
							initial="hidden"
							variants={ container }
							className="link-kort__container"
						>
							{ links.map((link, idx) => (
								<motion.div
									variants={ item }
									key={ idx }
								>
									<LinkKort { ...link } />
								</motion.div>
							)) }
						</motion.div>
					) }
				</section>
			</div>
		</div>
	);
};

export default LinkListe;
